import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import './ListeLoge.css';

interface Loge {
  id: string;
  nom: string;
  orient: string;
  date: string;
  jour: string;
  presentation: string;
  adresseTemple: string;
}

function ListeLoges() {
  const navigate = useNavigate();
  const [loges, setLoges] = useState<Loge[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
          setError('Utilisateur non connecté');
          setLoading(false);
          return;
        }

        const db = getFirestore();

        // 1) Obtenir les loges de l'utilisateur connecté
        const membresRef = collection(db, 'Membres');
        const userQuery = query(membresRef, where('mail', '==', user.email));
        const userSnapshot = await getDocs(userQuery);

        if (userSnapshot.empty) {
          setError('Membre non trouvé');
          setLoading(false);
          return;
        }

        const userData = userSnapshot.docs[0].data();

        let userLoges: string[] = [];
        if (userData.loges && Array.isArray(userData.loges)) {
          userLoges = userData.loges;
        } else if (userData.loge) {
          userLoges = [userData.loge];
        }

        console.log("🔍 Loges de l'utilisateur:", userLoges);

        // 2) Récupérer toutes les loges
        const logesRef = collection(db, 'Loges');
        const logesSnapshot = await getDocs(logesRef);

        const logesData: Loge[] = logesSnapshot.docs
          .map((d) => {
            const logeData: any = d.data();
            const logeName = logeData.nom || d.id;

            return {
              id: d.id,
              nom: logeName,
              orient: logeData.orient || '',
              date: logeData.date || '',
              jour: logeData.jour || '',
              presentation: logeData.presentation || '',
              adresseTemple: logeData.adresseTemple || '',
            };
          })
          // ✅ Exclure si l'utilisateur a déjà cette loge (par id OU par nom)
          .filter((l) => !userLoges.includes(l.id) && !userLoges.includes(l.nom));

        console.log("✅ Loges affichées:", logesData.length);
        setLoges(logesData);
        setLoading(false);
      } catch (err) {
        console.error('❌ Erreur lors de la récupération des données:', err);
        setError('Erreur lors de la récupération des données');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ✅ IMPORTANT : encodeURIComponent pour éviter les bugs avec espaces/apostrophes
  const handleAfficher = (logeId: string) => {
    navigate(`/mapage/les-loges/${encodeURIComponent(logeId)}`);
  };

  if (loading) return <div className="loading">Chargement...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="liste-loges-container">
      <h1>Liste des Loges</h1>

      <div className="table-container">
        <table className="loges-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Orient</th>
              <th>Tenue</th>
              <th>Temple</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loges.length === 0 ? (
              <tr>
                <td colSpan={5} style={{ textAlign: 'center', padding: '20px' }}>
                  Aucune autre loge disponible
                </td>
              </tr>
            ) : (
              loges.map((loge) => (
                <tr key={loge.id}>
                  <td>{loge.nom}</td>
                  <td>{loge.orient}</td>
                  <td>{loge.date} {loge.jour}</td>
                  <td>{loge.adresseTemple}</td>
                  <td>
                    <button
                      onClick={() => handleAfficher(loge.id)}
                      className="action-button view-button"
                    >
                      Afficher
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListeLoges;
